// frontend/src/lib/motion.ts
// Pautas de movimiento de la PWA (Motion, motion.dev). Sobrias y rápidas,
// estilo iOS. La app Expo usa los mismos valores con Reanimated.

import type { Transition } from 'motion/react';

// Duraciones en segundos
export const DUR = {
  rapida: 0.15,
  base: 0.22,
  sheet: 0.32,
} as const;

// Curva de los sheets de iOS
export const EASE_IOS = [0.32, 0.72, 0, 1] as const;
// Salida: acelera hacia el final
export const EASE_SALIDA = [0.4, 0, 1, 1] as const;

export const SPRING: Transition = { type: 'spring', stiffness: 500, damping: 38 };
// Rebote corto para confirmaciones ("pop")
export const SPRING_POP: Transition = { type: 'spring', stiffness: 600, damping: 18 };

export const TRANSICION_BASE: Transition = { duration: DUR.base, ease: EASE_IOS };

// Presets para modales centrados: se esparcen sobre <m.div> dentro de un
// <AnimatePresence> (la salida corre al desmontar el modal).
export const MODAL_OVERLAY = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: DUR.base } },
  exit: { opacity: 0, transition: { duration: DUR.rapida, ease: EASE_SALIDA } },
} as const;

export const MODAL_TARJETA = {
  initial: { opacity: 0, scale: 0.96, y: 8 },
  animate: { opacity: 1, scale: 1, y: 0, transition: { duration: DUR.base, ease: EASE_IOS } },
  exit: { opacity: 0, scale: 0.97, transition: { duration: DUR.rapida, ease: EASE_SALIDA } },
} as const;
